import {
    CHAT_MEDIA_TYPES,
    CHAT_MESSAGE_DIRECTIONS,
    CHAT_MESSAGE_FAILED_REASONS,
    CHAT_MESSAGE_STATUSES,
} from 'cpool-constants';
import { schemaChatTemplateButton, schemaId } from 'cpool-schemas';
import { z } from 'zod';

// messageId = our uuid (minted inbound); metaMessageId = Meta WAMID (idempotency/receipts) — keep separate.
// Inbound media only — projected for DSGVO delete without replaying the event log.
export const ChatMessagesTableDefinitionZod = z.object({
    buttons: z.array(schemaChatTemplateButton).nullish(),
    chatId: schemaId,
    content: z.string().nullable(),
    direction: z.nativeEnum(CHAT_MESSAGE_DIRECTIONS),
    failureReason: z.nativeEnum(CHAT_MESSAGE_FAILED_REASONS).nullable(),
    // nullish: pre-field rows omit the key (undefined ≠ null).
    failureReasonDetail: z.string().nullish(),
    header: z.string().min(1).nullish(),
    // Filename for download/display — content is caption / [attachment] placeholder.
    mediaFileName: z.string().min(1).nullish(),
    mediaKey: z.string().min(1).nullable(),
    mediaType: z.nativeEnum(CHAT_MEDIA_TYPES).nullable(),
    messageId: schemaId,
    metaMediaId: z.string().min(1).nullable(),
    metaMessageId: z.string().min(1).nullable(),
    // nullish: pre-field rows omit the key. null = no reaction / removed (normalized upstream in manta's
    // schemaInboundMessage — Meta omits `emoji` on removal, not ''). Latest reaction only, no history.
    reactionEmoji: z.string().nullish(),
    // WAMID this message replies to; reference not snapshot, so censoring the original censors the quote.
    repliedToMetaMessageId: z.string().min(1).nullish(),
    sequence: z.number().int().nonnegative(),
    status: z.nativeEnum(CHAT_MESSAGE_STATUSES),
    timestamp: z.number(),
});

export type ChatMessagesTableSchema = z.infer<typeof ChatMessagesTableDefinitionZod>;
